// extracted by mini-css-extract-plugin
module.exports = {"followContainer":"styles-module_followContainer_1VPlx","content":"styles-module_content_tf9vk","followed":"styles-module_followed_ap3_6"};